var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import store from "../../reduxStore/store";
import { GetProductDataService, getLoggedInRepDetails } from "../../services/apiServices/salesRepDataService";
import { useTranslation } from "react-i18next";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import { AffiliateLinkContactCardBL } from "../AffiliateLinkContactCard/AffiliateLinkContactCardBL";
import { gettingCartData } from "../../reduxStore/actions/salesRepDataAction";
import { COLLECTION_PAGE_SIZE } from "../Constant";
import { fetchAllProductsForCollections } from "../../reduxStore/actions/salesRepDataAction";
export function ProductTableUsingGraphQLBL(props) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var dispatch = useDispatch();
    var t = useTranslation().t; //* Translation *
    var _j = getLoggedInRepDetails(), shopCurrency = _j.shopCurrency, currency = _j.currency;
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); });
    var selectFeatures = ((_a = salesRepData.baseData) === null || _a === void 0 ? void 0 : _a.select) ? (_b = salesRepData.baseData) === null || _b === void 0 ? void 0 : _b.select : {};
    var _k = useState(""), productSearchText = _k[0], setProductSearchText = _k[1];
    var _l = useState(false), searchTablePopupOpen = _l[0], setSearchTablePopupOpen = _l[1];
    var _m = useState(false), getProductsLoading = _m[0], setGetProductsLoading = _m[1];
    var _o = useState([]), productsArray = _o[0], setProductsArray = _o[1];
    var _p = useState([]), selectedProductArray = _p[0], setSelectedProductArray = _p[1];
    var _q = useState([]), selectedProductIdArray = _q[0], setSelectedProductIdArray = _q[1];
    var _r = useState([]), selectedVariantArray = _r[0], setSelectedVariantArray = _r[1];
    var _s = useState({}), netQuantitySubtotal = _s[0], setNetQuantitySubtotal = _s[1];
    var _t = useState([]), finalSelectedProducts = _t[0], setFinalSelectedProducts = _t[1];
    var _u = useState(false), uncheckedFlag = _u[0], setUncheckedFlag = _u[1];
    var _v = useState(), pageInfo = _v[0], setPageInfo = _v[1];
    var _w = useState(0), collectionProductsPageIndex = _w[0], setCollectionProductsPageIndex = _w[1];
    var getListToPaginate = function () { return collectionProductsData !== null && collectionProductsData !== void 0 ? collectionProductsData : []; };
    var applyCollectionPage = function (list, pageIndex) {
        setCollectionProductsPageIndex(pageIndex);
        setProductsArray(list.slice(pageIndex * COLLECTION_PAGE_SIZE, (pageIndex + 1) * COLLECTION_PAGE_SIZE));
        setPageInfo({
            hasNextPage: list.length > (pageIndex + 1) * COLLECTION_PAGE_SIZE,
            hasPreviousPage: pageIndex > 0,
        });
    };
    var _x = useState({ msg: "", open: false }), alertErrorMsg = _x[0], setAlertErrorMsg = _x[1];
    var _y = useState({}), isQuantityError = _y[0], setIsQuantityError = _y[1];
    var storefrontAccessToken = (_c = store.getState().salesRepData.baseData) === null || _c === void 0 ? void 0 : _c.storefrontAccessToken;
    var cartCreatedSuccessFully = store.getState().salesRepData.cartShareProductData.cartCreatedSuccessFully;
    var shopName = (_f = (_e = (_d = store.getState().salesRepData) === null || _d === void 0 ? void 0 : _d.baseData) === null || _e === void 0 ? void 0 : _e.ShopDomainName) !== null && _f !== void 0 ? _f : (_h = (_g = store.getState().salesRepData) === null || _g === void 0 ? void 0 : _g.baseData) === null || _h === void 0 ? void 0 : _h.ShopName;
    var collectionProductsData = useSelector(function () { var _a, _b; return (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.collectionProductsData) !== null && _b !== void 0 ? _b : []; });
    var isShowSpecificProducts = selectFeatures.featuresAdditionalSettings.showProducts === "showSpecific";
    var _z = useState(null), hoveredIconIndex = _z[0], setHoveredIconIndex = _z[1];
    var _0 = AffiliateLinkContactCardBL(), commissionDiscountType = _0.commissionDiscountType, commissionOn = _0.commissionOn, CheckPopUpInitialValue = _0.CheckPopUpInitialValue, affiliateUrl = _0.affiliateUrl, commissionPerProduct = _0.commissionPerProduct;
    var ProductTableHeaders = [
        { name: "ST_Producttable_product", hide: false },
        { name: "ST_Producttable_SKU", hide: false },
        { name: "customerInvoice_ProductTableColumnInventory", hide: false },
        { name: "Price_Unit", hide: false },
        { name: "ST_Producttable_netQuantity", hide: (props === null || props === void 0 ? void 0 : props.activeTabIndex) === 3 },
        { name: "affliateOrder_column6", hide: (props === null || props === void 0 ? void 0 : props.activeTabIndex) === 4 || commissionOn !== "Product" },
        { name: "affiliate_product_link", hide: (props === null || props === void 0 ? void 0 : props.activeTabIndex) === 4 },
        { name: "", hide: false }, // Delete variant button
    ];
    var searchDialogProductTableHeaders = [
        { name: "ST_Producttable_product", hide: false },
        { name: "customerInvoice_ProductTableColumnInventory", hide: false },
        { name: "ST_Producttable_retailPrice", hide: false },
    ];
    var tableContainerRef = useRef(null);
    useEffect(function () {
        if (cartCreatedSuccessFully) {
            removeAllSelectedProducts();
        }
    }, [cartCreatedSuccessFully]);
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.activeTabIndex) === 4) {
            setFinalSelectedProducts(selectedProductArray);
        }
        else {
            var productsContent = formatProductsWithCommissionAndUrl(selectedProductArray);
            setFinalSelectedProducts(productsContent);
        }
    }, [uncheckedFlag]);
    useEffect(function () {
        handleReduxUpdate();
    }, [netQuantitySubtotal]);
    useEffect(function () {
        setFinalSelectedProducts([]);
        // If CartShare tab -> (index === 4)
        if ((props === null || props === void 0 ? void 0 : props.activeTabIndex) === 4) {
            setFinalSelectedProducts(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), selectedProductArray, true); });
        }
        else {
            var productsContent = formatProductsWithCommissionAndUrl(selectedProductArray);
            setFinalSelectedProducts(productsContent);
        }
        handleReduxUpdate();
    }, [selectedProductArray]);
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.activeTabIndex) === 4 && !(props === null || props === void 0 ? void 0 : props.editCartData)) {
            readCartProducts();
        }
    }, []);
    // Handle edit cart data when passed from parent
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.editCartData) && (props === null || props === void 0 ? void 0 : props.isEditMode)) {
            populateEditCartData(props.editCartData);
        }
    }, [props === null || props === void 0 ? void 0 : props.editCartData, props === null || props === void 0 ? void 0 : props.isEditMode]);
    // Clear products when exiting edit mode
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.isEditMode) === false && (props === null || props === void 0 ? void 0 : props.clearEditMode)) {
            removeAllSelectedProducts();
        }
    }, [props === null || props === void 0 ? void 0 : props.isEditMode]);
    var populateEditCartData = function (cartData) {
        try {
            if (!(cartData === null || cartData === void 0 ? void 0 : cartData.CartProductDetails) || !Array.isArray(cartData.CartProductDetails))
                return;
            var newSelectedProducts_1 = [];
            var newSelectedVariants_1 = [];
            var newNetQuantitySubtotal_1 = {};
            var newSelectedProductIds_1 = [];
            var productMap_1 = {};
            cartData.CartProductDetails.forEach(function (cartItem) {
                var _a, _b;
                var variantId = cartItem.VariantId || cartItem.variantId || cartItem.id;
                var quantity = cartItem.OriginalQuantity !== undefined ? cartItem.OriginalQuantity : cartItem.Quantity !== undefined ? cartItem.Quantity : cartItem.quantity || 1;
                if (!variantId)
                    return;
                // Create variant object from cart item data
                var variant = {
                    variantId: String(variantId).includes("gid://") ? variantId : "gid://shopify/ProductVariant/".concat(variantId),
                    title: cartItem.VariantTitle || cartItem.title || "Default Title",
                    variantPrice: cartItem.Price || cartItem.price || 0,
                    sku: cartItem.SKU || cartItem.sku || "",
                    quantityAvailable: (_b = (_a = cartItem.quantityAvailable) !== null && _a !== void 0 ? _a : cartItem.InventoryQuantity) !== null && _b !== void 0 ? _b : "NA",
                    availableForSale: cartItem.availableForSale !== false,
                    imageUrl: cartItem.ImageUrl || cartItem.imageUrl || "",
                    currency: shopCurrency,
                    inventoryQuantity: cartItem.InventoryQuantity || cartItem.inventoryQuantity || 0,
                    quantity: quantity,
                    wholesalePrice: cartItem.Price || cartItem.price || 0,
                };
                // Create or update product
                var productId = cartItem.ProductId || cartItem.productId || "product_".concat(variantId);
                var productIdString = String(productId).includes("gid://") ? productId : "gid://shopify/Product/".concat(productId);
                if (!productMap_1[productIdString]) {
                    productMap_1[productIdString] = {
                        productId: productIdString,
                        title: cartItem.ProductTitle || cartItem.title || "Product",
                        imageUrl: cartItem.ImageUrl || cartItem.imageUrl || null,
                        variants: [],
                    };
                    newSelectedProductIds_1.push(productIdString);
                }
                productMap_1[productIdString].variants.push(variant);
                newSelectedVariants_1.push(variant);
                newNetQuantitySubtotal_1[variant.variantId] = { quantity: quantity };
            });
            Object.values(productMap_1).forEach(function (product) { return newSelectedProducts_1.push(product); });
            setSelectedProductArray(newSelectedProducts_1);
            setSelectedVariantArray(newSelectedVariants_1);
            setSelectedProductIdArray(newSelectedProductIds_1);
            setNetQuantitySubtotal(newNetQuantitySubtotal_1);
            setFinalSelectedProducts(newSelectedProducts_1);
        }
        catch (error) {
            console.error("Error populating edit cart data:", error);
            setAlertErrorMsg({ msg: t("cartSharing_CartCreateError_Msg") || "Error loading cart data. Please try again.", open: true, severity: "error" });
        }
    };
    // Search Product Function
    var handleSearchProductData = function (startCursor, endCursor, makeEmpty) { return __awaiter(_this, void 0, void 0, function () {
        var activeCollectionList, collectionIds, allProducts, action, _a, newProducts, newPageInfo, error_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 7, , 8]);
                    setGetProductsLoading(true);
                    activeCollectionList = (_c = (_b = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.baseData) === null || _b === void 0 ? void 0 : _b.activeCollectionList) !== null && _c !== void 0 ? _c : [];
                    if (!(isShowSpecificProducts && (activeCollectionList === null || activeCollectionList === void 0 ? void 0 : activeCollectionList.length) > 0)) return [3 /*break*/, 4];
                    if (!(collectionProductsData && (collectionProductsData === null || collectionProductsData === void 0 ? void 0 : collectionProductsData.length) > 0)) return [3 /*break*/, 1];
                    if (productSearchText !== "" && isShowSpecificProducts) {
                        filterProductsForSpecificCollections(collectionProductsData);
                    }
                    else {
                        applyCollectionPage(collectionProductsData, 0);
                    }
                    return [3 /*break*/, 3];
                case 1:
                    collectionIds = activeCollectionList.map(function (c) { return c === null || c === void 0 ? void 0 : c.CollectionId; });
                    return [4 /*yield*/, fetchAllProductsForCollections(collectionIds, productSearchText, storefrontAccessToken !== null && storefrontAccessToken !== void 0 ? storefrontAccessToken : "")];
                case 2:
                    allProducts = _d.sent();
                    action = {
                        payload: allProducts,
                        type: SalesRepDataActionType.COLLECTION_PRODUCTS_DATA,
                    };
                    dispatch(action);
                    applyCollectionPage(allProducts, 0);
                    _d.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, GetProductDataService(makeEmpty == "" ? "" : productSearchText, storefrontAccessToken, startCursor, endCursor).then(function (data) { return data; })];
                case 5:
                    _a = _d.sent(), newProducts = _a.products, newPageInfo = _a.pageInfo;
                    if (makeEmpty == "") {
                        setProductsArray(newProducts);
                    }
                    else {
                        filterProductsForSpecificCollections(newProducts);
                    }
                    setPageInfo(newPageInfo);
                    _d.label = 6;
                case 6:
                    setGetProductsLoading(false);
                    return [3 /*break*/, 8];
                case 7:
                    error_1 = _d.sent();
                    console.error("Error fetching products:", error_1);
                    setGetProductsLoading(false);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handlePrevClick = function () {
        var _a, _b;
        if (isShowSpecificProducts && (collectionProductsData === null || collectionProductsData === void 0 ? void 0 : collectionProductsData.length) > 0) {
            if (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasPreviousPage) {
                var list = getListToPaginate();
                applyCollectionPage(list, collectionProductsPageIndex - 1);
                (_a = tableContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
            }
        }
        else if (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasPreviousPage) {
            handleSearchProductData("", pageInfo.startCursor);
            (_b = tableContainerRef.current) === null || _b === void 0 ? void 0 : _b.scrollTo(0, 0);
        }
    };
    var handleNextClick = function () {
        var _a, _b;
        if (isShowSpecificProducts && (collectionProductsData === null || collectionProductsData === void 0 ? void 0 : collectionProductsData.length) > 0) {
            if (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage) {
                var list = getListToPaginate();
                applyCollectionPage(list, collectionProductsPageIndex + 1);
                (_a = tableContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
            }
        }
        else if (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage) {
            handleSearchProductData(pageInfo.endCursor, "");
            (_b = tableContainerRef.current) === null || _b === void 0 ? void 0 : _b.scrollTo(0, 0);
        }
    };
    var handleProductTableSearchPopup = function () {
        setSearchTablePopupOpen(true);
        handleSearchProductData();
    };
    var closePopupForSearchProductData = function () {
        setSearchTablePopupOpen(false);
        setGetProductsLoading(false);
        makeFieldsEmpty();
    };
    var makeFieldsEmpty = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setProductSearchText("");
                    if (!isShowSpecificProducts) return [3 /*break*/, 1];
                    applyCollectionPage(collectionProductsData, 0);
                    return [3 /*break*/, 3];
                case 1:
                    setProductsArray([]);
                    return [4 /*yield*/, handleSearchProductData("", "", "")];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    if ((props === null || props === void 0 ? void 0 : props.activeTabIndex) === 4) {
                        props === null || props === void 0 ? void 0 : props.setOpenSearchProducts(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSearchTextChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            value = e.target.value;
            setProductSearchText(value);
            if (isShowSpecificProducts) {
                if (value === "") {
                    applyCollectionPage(collectionProductsData, 0);
                }
                else {
                    filterProductsForSpecificCollections(collectionProductsData);
                }
            }
            return [2 /*return*/];
        });
    }); };
    var filterProductsForSpecificCollections = function (collectionProductsArray) {
        applyCollectionPage(collectionProductsArray, 0);
    };
    var handleKeyDown = function (event) {
        if (event.key === "Enter" && event.keyCode === 13) {
            if (productSearchText !== "" && isShowSpecificProducts) {
                filterProductsForSpecificCollections(collectionProductsData);
            }
            else {
                handleSearchProductData();
            }
        }
    };
    // Function to toggle the selection of a variant
    function checkUncheckProductVariant(event, type, product, variant, uncheckFromSelected) {
        try {
            var checked = event.target.checked;
            if (type === "isProduct") {
                var tempVariantsObj_1 = product === null || product === void 0 ? void 0 : product.variants;
                if (checked) {
                    var filteredVariants = tempVariantsObj_1 === null || tempVariantsObj_1 === void 0 ? void 0 : tempVariantsObj_1.filter(function (variant) { return variant.availableForSale; }); // Filter out variants where availableForSale is false
                    if (selectedProductArray === null || selectedProductArray === void 0 ? void 0 : selectedProductArray.some(function (item) { return item.productId === product.productId; })) {
                        // Product already exists, update the variants array
                        var existingProductIndex = selectedProductArray.findIndex(function (item) { return item.productId === product.productId; });
                        if (existingProductIndex !== -1) {
                            var updatedSelectedData = __spreadArray([], selectedProductArray, true);
                            updatedSelectedData[existingProductIndex].variants = filteredVariants;
                            setSelectedProductArray(updatedSelectedData);
                        }
                    }
                    else {
                        // Product not present, add it with the new variant
                        setSelectedProductArray(__spreadArray(__spreadArray([], selectedProductArray, true), [__assign(__assign({}, product), { variants: filteredVariants })], false));
                        setSelectedProductIdArray(__spreadArray(__spreadArray([], selectedProductIdArray, true), [product.productId], false));
                    }
                    setSelectedVariantArray(__spreadArray(__spreadArray([], selectedVariantArray, true), filteredVariants, true));
                    // Update net quantity subtotal
                    var updatedNetQuantitySubtotal_1 = __assign({}, netQuantitySubtotal);
                    filteredVariants === null || filteredVariants === void 0 ? void 0 : filteredVariants.forEach(function (variantToAdd) {
                        updatedNetQuantitySubtotal_1[variantToAdd.variantId] = {
                            quantity: 1,
                        };
                    });
                    setNetQuantitySubtotal(updatedNetQuantitySubtotal_1);
                }
                else {
                    // Uncheck product
                    setUncheckedFlag(!uncheckedFlag);
                    setSelectedProductArray(selectedProductArray === null || selectedProductArray === void 0 ? void 0 : selectedProductArray.filter(function (item) { return item.productId !== product.productId; }));
                    setSelectedProductIdArray(selectedProductIdArray === null || selectedProductIdArray === void 0 ? void 0 : selectedProductIdArray.filter(function (id) { return id !== product.productId; }));
                    var updatedSelectedVariantObject = selectedVariantArray === null || selectedVariantArray === void 0 ? void 0 : selectedVariantArray.filter(function (selectedVariant) { return !(tempVariantsObj_1 === null || tempVariantsObj_1 === void 0 ? void 0 : tempVariantsObj_1.some(function (tempVariant) { return (tempVariant === null || tempVariant === void 0 ? void 0 : tempVariant.variantId) === (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.variantId); })); });
                    setSelectedVariantArray(updatedSelectedVariantObject);
                    // this will Uncheck from selected products table
                    if (uncheckFromSelected) {
                        var updatedNetQuantitySubtotal_2 = __assign({}, netQuantitySubtotal);
                        tempVariantsObj_1 === null || tempVariantsObj_1 === void 0 ? void 0 : tempVariantsObj_1.forEach(function (variantToRemove) {
                            delete updatedNetQuantitySubtotal_2[variantToRemove === null || variantToRemove === void 0 ? void 0 : variantToRemove.variantId];
                        });
                        setNetQuantitySubtotal(updatedNetQuantitySubtotal_2);
                    }
                }
            }
            else {
                if (checked) {
                    // isVariant
                    if (!(selectedProductArray === null || selectedProductArray === void 0 ? void 0 : selectedProductArray.some(function (item) { return item.productId === product.productId; }))) {
                        // Product not present, add it with the new variant
                        setSelectedProductArray(__spreadArray(__spreadArray([], selectedProductArray, true), [__assign(__assign({}, product), { variants: [variant] })], false));
                        setSelectedProductIdArray(__spreadArray(__spreadArray([], selectedProductIdArray, true), [product.productId], false));
                    }
                    else {
                        // Product already exists, update the variants array
                        setSelectedProductArray(function (prevSelectedData) {
                            return prevSelectedData === null || prevSelectedData === void 0 ? void 0 : prevSelectedData.map(function (item) { return (item.productId === product.productId ? __assign(__assign({}, item), { variants: __spreadArray(__spreadArray([], item.variants, true), [variant], false) }) : item); });
                        });
                    }
                    setSelectedVariantArray(__spreadArray(__spreadArray([], selectedVariantArray, true), [variant], false));
                    // Update net quantity subtotal
                    setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                        var _a;
                        return (__assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variant === null || variant === void 0 ? void 0 : variant.variantId] = {
                            quantity: 1,
                        }, _a)));
                    });
                }
                else {
                    // Uncheck variant
                    setUncheckedFlag(!uncheckedFlag);
                    setSelectedVariantArray(function (prevSelectedVariantObject) { return prevSelectedVariantObject === null || prevSelectedVariantObject === void 0 ? void 0 : prevSelectedVariantObject.filter(function (v) { return (v === null || v === void 0 ? void 0 : v.variantId) !== (variant === null || variant === void 0 ? void 0 : variant.variantId); }); });
                    setSelectedProductArray(function (prevSelectedData) {
                        return prevSelectedData === null || prevSelectedData === void 0 ? void 0 : prevSelectedData.map(function (item) { var _a; return item.productId === product.productId ? __assign(__assign({}, item), { variants: (_a = item.variants) === null || _a === void 0 ? void 0 : _a.filter(function (v) { return (v === null || v === void 0 ? void 0 : v.variantId) !== (variant === null || variant === void 0 ? void 0 : variant.variantId); }) }) : item; });
                    });
                    var tempVariants_1 = product === null || product === void 0 ? void 0 : product.variants;
                    setSelectedVariantArray(function (prevSelectedVariantObject) {
                        var variantFoundInSelectedArray = tempVariants_1 === null || tempVariants_1 === void 0 ? void 0 : tempVariants_1.some(function (tempVariant) {
                            return prevSelectedVariantObject === null || prevSelectedVariantObject === void 0 ? void 0 : prevSelectedVariantObject.some(function (selectedVariant) { return (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.variantId) === (tempVariant === null || tempVariant === void 0 ? void 0 : tempVariant.variantId); });
                        });
                        if (!variantFoundInSelectedArray) {
                            setSelectedProductIdArray(function (prevSelectedProductIdObject) { return prevSelectedProductIdObject === null || prevSelectedProductIdObject === void 0 ? void 0 : prevSelectedProductIdObject.filter(function (id) { return id !== product.productId; }); });
                            setSelectedProductArray(function (prevSelectedData) { return prevSelectedData === null || prevSelectedData === void 0 ? void 0 : prevSelectedData.filter(function (item) { return item.productId !== product.productId; }); });
                        }
                        return prevSelectedVariantObject === null || prevSelectedVariantObject === void 0 ? void 0 : prevSelectedVariantObject.filter(function (v) { return (v === null || v === void 0 ? void 0 : v.variantId) !== (variant === null || variant === void 0 ? void 0 : variant.variantId); });
                    });
                    // this will Uncheck from selected products table
                    if (uncheckFromSelected) {
                        var updatedNetQuantitySubtotal = __assign({}, netQuantitySubtotal);
                        delete updatedNetQuantitySubtotal[variant === null || variant === void 0 ? void 0 : variant.variantId];
                        setNetQuantitySubtotal(updatedNetQuantitySubtotal);
                    }
                }
            }
        }
        catch (error) {
            return;
        }
    }
    var handleReduxUpdate = function () {
        var productDetails = [];
        selectedProductArray === null || selectedProductArray === void 0 ? void 0 : selectedProductArray.forEach(function (product) {
            var _a;
            (_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.forEach(function (variant) {
                var _a, _b;
                var splitedVariantId = Number((_a = variant === null || variant === void 0 ? void 0 : variant.variantId) === null || _a === void 0 ? void 0 : _a.split("gid://shopify/ProductVariant/")[1]);
                productDetails.push(__assign({ id: splitedVariantId, quantity: ((_b = netQuantitySubtotal[variant === null || variant === void 0 ? void 0 : variant.variantId]) === null || _b === void 0 ? void 0 : _b.quantity) || 1, handle: product.handle }, (variant.selling_plan_id && { selling_plan: variant.selling_plan_id })));
            });
        });
        var action = {
            payload: productDetails,
            type: SalesRepDataActionType.CART_SHARE_PRODUCT_DATA,
        };
        dispatch(action);
    };
    // Add Button Call to show selected products
    var showSelectedProduct = function () {
        try {
            setSearchTablePopupOpen(false);
            makeFieldsEmpty();
            handleReduxUpdate();
        }
        catch (error) {
            return;
        }
    };
    function updateNetQuantitySubtotal(value, variantId, actionType) {
        // Check if value is empty
        var _a;
        if (value !== "" && value !== "0" && Number(value) > 0) {
            var updatedQuantity_1;
            // Reset error state if there's no error
            setIsQuantityError(function (prevIsError) {
                var _a;
                return (__assign(__assign({}, prevIsError), (_a = {}, _a[variantId] = false, _a)));
            });
            setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                var _a;
                var currentVariant = prevNetQuantitySubtotal[variantId];
                if (actionType === "increaseQty") {
                    updatedQuantity_1 = Number(currentVariant.quantity) + 1;
                }
                else if (actionType === "decreaseQty") {
                    // "subtract"
                    updatedQuantity_1 = Math.max(Number(currentVariant.quantity) - 1, 1);
                }
                else {
                    // if Manually entered number
                    updatedQuantity_1 = Number(value);
                }
                var updatedNetQuantitySubtotal = __assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variantId] = {
                    quantity: updatedQuantity_1,
                }, _a));
                return updatedNetQuantitySubtotal;
            });
        }
        else {
            setAlertErrorMsg({ msg: t("productTable_error_AlertMsg"), open: true });
            setIsQuantityError(__assign(__assign({}, isQuantityError), (_a = {}, _a[variantId] = true, _a)));
            setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                var _a;
                return (__assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variantId] = __assign(__assign({}, prevNetQuantitySubtotal[variantId]), { quantity: value }), _a)));
            });
            return;
        }
    }
    var removeAllSelectedProducts = function () {
        try {
            setFinalSelectedProducts([]);
            setNetQuantitySubtotal({});
            setSelectedProductIdArray([]);
            setSelectedVariantArray([]);
            setSelectedProductArray([]);
            makeFieldsEmpty();
            if ((props === null || props === void 0 ? void 0 : props.activeTabIndex) === 4) {
                props === null || props === void 0 ? void 0 : props.setIsRemoveSelectedProduct(false);
            }
        }
        catch (error) {
            return;
        }
    };
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setAlertErrorMsg({ msg: "", open: false });
    };
    function formatProductsWithCommissionAndUrl(productsData) {
        var tableArray = [];
        productsData === null || productsData === void 0 ? void 0 : productsData.forEach(function (product) {
            var _a, _b;
            var url = affiliateUrl(shopName, product.handle);
            var variantsArray = [];
            if (((_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                (_b = product === null || product === void 0 ? void 0 : product.variants) === null || _b === void 0 ? void 0 : _b.forEach(function (variant) {
                    var _a;
                    var splitedVariantId = Number((_a = variant === null || variant === void 0 ? void 0 : variant.variantId) === null || _a === void 0 ? void 0 : _a.split("gid://shopify/ProductVariant/")[1]);
                    var commission = commissionPerProduct(variant.product_type, splitedVariantId) || 0;
                    variantsArray.push({
                        variantId: variant === null || variant === void 0 ? void 0 : variant.variantId,
                        title: variant === null || variant === void 0 ? void 0 : variant.title,
                        variantPrice: variant === null || variant === void 0 ? void 0 : variant.variantPrice,
                        commission: commission,
                        handle: product === null || product === void 0 ? void 0 : product.handle,
                        url: url,
                        sku: variant.sku,
                        quantityAvailable: variant === null || variant === void 0 ? void 0 : variant.quantityAvailable,
                    });
                });
            }
            // Push the product object with its variants into the tableArray
            tableArray.push({
                productId: product === null || product === void 0 ? void 0 : product.productId,
                title: product === null || product === void 0 ? void 0 : product.title,
                imageUrl: product === null || product === void 0 ? void 0 : product.imageUrl,
                variants: variantsArray,
            });
        });
        return tableArray;
    }
    var readCartProducts = function () { return __awaiter(_this, void 0, void 0, function () {
        var responseGetCart, productsArray_1, updatedSelectedProductIdObject;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, dispatch(gettingCartData())];
                case 1:
                    responseGetCart = _d.sent();
                    if ((responseGetCart === null || responseGetCart === void 0 ? void 0 : responseGetCart.status) === 200 && ((_b = (_a = responseGetCart === null || responseGetCart === void 0 ? void 0 : responseGetCart.data) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                        setGetProductsLoading(true);
                        productsArray_1 = handleMakeFormatArray((_c = responseGetCart === null || responseGetCart === void 0 ? void 0 : responseGetCart.data) === null || _c === void 0 ? void 0 : _c.items);
                        setFinalSelectedProducts(productsArray_1);
                        setSelectedProductArray(productsArray_1);
                        updatedSelectedProductIdObject = productsArray_1 === null || productsArray_1 === void 0 ? void 0 : productsArray_1.map(function (_a) {
                            var productId = _a.productId;
                            return productId;
                        });
                        setSelectedProductIdArray(updatedSelectedProductIdObject);
                        handleReduxUpdate();
                    }
                    setGetProductsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleMakeFormatArray = function (cartProducts) {
        var formattedOutput = [];
        var newSelectedVariants = [];
        cartProducts === null || cartProducts === void 0 ? void 0 : cartProducts.forEach(function (inputObject) {
            var _a, _b, _c, _d, _e;
            var existingProductIndex = formattedOutput.findIndex(function (product) { return product.productId === "gid://shopify/Product/" + inputObject.product_id; });
            var formattedVariant = {
                variantId: "gid://shopify/ProductVariant/" + inputObject.variant_id,
                variantPrice: inputObject.final_price / 100,
                imageUrl: ((_a = inputObject.featured_image) === null || _a === void 0 ? void 0 : _a.url) || "",
                currency: shopCurrency,
                inventoryQuantity: inputObject.quantity,
                sku: inputObject.sku,
                title: inputObject.variant_title || "Default Title",
                quantityAvailable: (_b = inputObject.quantity) !== null && _b !== void 0 ? _b : "NA",
                availableForSale: true,
                quantity: inputObject.quantity,
                wholesalePrice: inputObject.final_price / 100,
                selling_plan_id: (_d = (_c = inputObject === null || inputObject === void 0 ? void 0 : inputObject.selling_plan_allocation) === null || _c === void 0 ? void 0 : _c.selling_plan) === null || _d === void 0 ? void 0 : _d.id,
            };
            if (existingProductIndex !== -1) {
                // If the product already exists, add the variant to its variants array
                formattedOutput[existingProductIndex].variants.push(formattedVariant);
            }
            else {
                // If the product doesn't exist, create a new product and add it to the formattedOutput
                var productModel = {
                    productId: "gid://shopify/Product/" + inputObject.product_id,
                    title: inputObject.title,
                    variants: [formattedVariant],
                    imageUrl: ((_e = inputObject.featured_image) === null || _e === void 0 ? void 0 : _e.url) || null,
                };
                formattedOutput.push(productModel);
            }
            newSelectedVariants.push(formattedVariant);
        });
        // Update selectedVariantArray state with all new variants
        setSelectedVariantArray(function (prevSelectedVariantObject) { return __spreadArray(__spreadArray([], prevSelectedVariantObject, true), newSelectedVariants, true); });
        setSelectedProductArray(formattedOutput);
        // Update net quantity subtotal for all variants
        newSelectedVariants === null || newSelectedVariants === void 0 ? void 0 : newSelectedVariants.forEach(function (formattedVariant) {
            updateNetQuantitySubtotal((formattedVariant === null || formattedVariant === void 0 ? void 0 : formattedVariant.quantity) || 1, formattedVariant.variantId, "manual");
        });
        return formattedOutput;
    };
    return {
        handleSearchProductData: handleSearchProductData,
        makeFieldsEmpty: makeFieldsEmpty,
        productSearchText: productSearchText,
        handleKeyDown: handleKeyDown,
        handleProductTableSearchPopup: handleProductTableSearchPopup,
        shopCurrency: shopCurrency,
        currency: currency,
        handleSearchTextChange: handleSearchTextChange,
        searchTablePopupOpen: searchTablePopupOpen,
        productsArray: productsArray,
        getProductsLoading: getProductsLoading,
        selectedProductArray: selectedProductArray,
        checkUncheckProductVariant: checkUncheckProductVariant,
        selectedVariantArray: selectedVariantArray,
        selectedProductIdArray: selectedProductIdArray,
        showSelectedProduct: showSelectedProduct,
        ProductTableHeaders: ProductTableHeaders,
        netQuantitySubtotal: netQuantitySubtotal,
        updateNetQuantitySubtotal: updateNetQuantitySubtotal,
        finalSelectedProducts: finalSelectedProducts,
        closePopupForSearchProductData: closePopupForSearchProductData,
        removeAllSelectedProducts: removeAllSelectedProducts,
        handleNextClick: handleNextClick,
        handlePrevClick: handlePrevClick,
        pageInfo: pageInfo,
        salesRepData: salesRepData,
        searchDialogProductTableHeaders: searchDialogProductTableHeaders,
        selectFeatures: selectFeatures,
        handleAlertMsgClose: handleAlertMsgClose,
        alertErrorMsg: alertErrorMsg,
        isQuantityError: isQuantityError,
        commissionDiscountType: commissionDiscountType,
        commissionOn: commissionOn,
        CheckPopUpInitialValue: CheckPopUpInitialValue,
        t: t,
        tableContainerRef: tableContainerRef,
        hoveredIconIndex: hoveredIconIndex,
        setHoveredIconIndex: setHoveredIconIndex,
    };
}
export function cssConstants() {
    var QuantityBtns = {
        background: "#F2F2F2",
        border: "1px solid #E0E0E0",
        color: "gray",
        minWidth: "40px !important",
    };
    var inputFieldQty = { width: "50px", m: "5px", textAlign: "center" };
    return {
        QuantityBtns: QuantityBtns,
        inputFieldQty: inputFieldQty,
    };
}
